import React from 'react';
import { Season } from '@1po/1po-bff-fe-spec/generated/tire/model/Season';
import TireStockDisplay from 'components/StockInfo/TireStockDisplay';
import TireFeaturesIcons from 'components/TireIcons/TireFeaturesIcons';
import { LIFECYCLE_W1, LIFECYCLE_W4 } from 'domains/catalog/Catalog.types';
import { Flex, MarginBox } from 'UI';

interface FeaturesBlockProps {
  partNumber: string;
  season?: Season | string;
  extraLoad?: string;
  runFlat?: string;
  pmsf?: string;
  selfSeal?: string;
  lifeCycle?: string;
  rimsProtection?: string;
  marquage?: string[];
  renative?: boolean;
}

export const FeaturesBlock = ({
  partNumber,
  season,
  extraLoad,
  runFlat,
  pmsf,
  selfSeal,
  lifeCycle,
  rimsProtection,
  marquage,
  renative,
}: FeaturesBlockProps) => {
  const showStockSpinner = !(lifeCycle === LIFECYCLE_W1 || lifeCycle === LIFECYCLE_W4);

  return (
    <>
      <MarginBox mt={3} />
      <Flex>
        {showStockSpinner && (
          <MarginBox mr={15}>
            <TireStockDisplay referenceNumber={partNumber} size={40} spinSize="default" />
          </MarginBox>
        )}

        <TireFeaturesIcons
          season={season as Season}
          extraLoad={extraLoad}
          runFlat={runFlat}
          pmsf={pmsf}
          selfSeal={selfSeal}
          lifeCycle={lifeCycle}
          rimsProtection={rimsProtection}
          marquage={marquage}
          renative={renative}
        />
      </Flex>
    </>
  );
};
